var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"dash-card shadow-sm",attrs:{"border-variant":"0","no-body":_vm.noBody}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }